// TeamQuestionnaireDisplay.jsx
import React from 'react';
import QuestionCard from './QuestionCard';
import TeamResponsesCard from './TeamResponsesCard';

const TeamQuestionnaireDisplay = ({
  question,
  organizationResponse,
  userResponses = [],
  tempValue,
  comments = [],
  reactions = {},
  currentUser,
  teamMembers = [],
  error,
  saving,
  currency,
  onResponseChange,
  onCommentAdd,
  onReactionAdd,
  onLockToUser,
  organization,
  currentIndex,
  totalQuestions,
  onPrevious,
  onNext,
  onReview,
  canProgress,
  showReviewButton
}) => {
  // Debug logging
  console.log('TeamQuestionnaireDisplay props:', {
    question,
    userResponses,
    teamMembers,
    currentUser,
    reactions
  });

  const isAdmin = currentUser?.role === 'admin';
  const isViewer = currentUser?.role === 'viewer';

  return (
    <div className="space-y-4">
      {/* Question Card */}
      <QuestionCard
        question={question}
        tempValue={tempValue}
        error={error}
        saving={saving}
        organization={organization}
        isViewer={isViewer}
        onResponseChange={onResponseChange}
        currentIndex={currentIndex}
        totalQuestions={totalQuestions}
        onPrevious={onPrevious}
        onNext={onNext}
        onReview={onReview}
        canProgress={canProgress}
        showReviewButton={showReviewButton}
      />

      {/* Team Responses & Comments Card */}
      <TeamResponsesCard
        teamResponses={userResponses}
        comments={comments}
        reactions={reactions}
        currentUser={currentUser}
        teamMembers={teamMembers}
        onLockToUser={onLockToUser}
        onCommentAdd={onCommentAdd}
        onReactionAdd={onReactionAdd}
        isAdmin={isAdmin}
        isViewer={isViewer}
        question={question}
      />
    </div>
  );
};

export default TeamQuestionnaireDisplay;